module.exports = __webpack_public_path__ + "img/images/whyhost/Listingbenefits.png?ae5c6c16";